export enum StepType {
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  PASSWORD_RECOVERY = "PASSWORD_RECOVERY"
}
